import { CleanupTypeEnum } from "@/domain/models/common";
import { TasksType } from "@/domain/models/job";

export const checkTaskHasCleanupType = (task: TasksType | undefined) => {
  return Boolean(
    task?.cleanupType && task?.cleanupType !== CleanupTypeEnum.NONE,
  );
};
